import { match, P } from 'ts-pattern';
import { IxcRegistrationV1CheckOutcome, type IxcRegistrationV1ProfileCheck } from '@interxfi/types/generated/api';
import { determineIfRegistrationOutcomeRequiresAction } from '../../check/registration-check-helpers';

export function getProfileCheckOutcome(check: IxcRegistrationV1ProfileCheck) {
  return match(check.checkType)
    .with({ cipIdentity: P.not(P.nullish) }, (c) => c.cipIdentity.evidence?.outcome)
    .with({ cipIdentityMinimal: P.not(P.nullish) }, (c) => (c.cipIdentityMinimal.evidence ? IxcRegistrationV1CheckOutcome.Passed : undefined))
    .with({ cipOfac: P.not(P.nullish) }, (c) => c.cipOfac.evidence?.outcome)
    .with({ cipOfacMinimal: P.not(P.nullish) }, (c) => (c.cipOfacMinimal.evidence ? IxcRegistrationV1CheckOutcome.Passed : undefined))
    .with({ clearingManualProfileApproval: P.not(P.nullish) }, (c) => c.clearingManualProfileApproval.evidence?.outcome)
    .exhaustive(() => undefined);
}

export function getProfileCheckTimestamp(check: IxcRegistrationV1ProfileCheck) {
  return match(check.checkType)
    .with({ cipIdentity: P.not(P.nullish) }, (c) => c.cipIdentity.evidence?.timestamp)
    .with({ cipIdentityMinimal: P.not(P.nullish) }, (c) => c.cipIdentityMinimal.evidence?.timestamp)
    .with({ cipOfac: P.not(P.nullish) }, (c) => c.cipOfac.evidence?.timestamp)
    .with({ cipOfacMinimal: P.not(P.nullish) }, (c) => c.cipOfacMinimal.evidence?.timestamp)
    .with({ clearingManualProfileApproval: P.not(P.nullish) }, (c) => c.clearingManualProfileApproval.evidence?.timestamp)
    .exhaustive(() => undefined);
}

export function determineProfileCheckRequiresAction(check: IxcRegistrationV1ProfileCheck) {
  return determineIfRegistrationOutcomeRequiresAction(getProfileCheckOutcome(check));
}
